import { useQuery } from '@tanstack/react-query';
import { telemetryApi, tripsApi, type TripQuery } from '@/lib/api/endpoints';
import { queryKeys } from './keys';
import type { Id } from '@/types/api';

export function useTrips(query?: TripQuery, enabled = true) {
  return useQuery({
    queryKey: queryKeys.trips.list(query),
    queryFn: () => tripsApi.list(query),
    enabled,
    placeholderData: (previous) => previous,
  });
}

export function useTrip(id: Id | null | undefined) {
  return useQuery({
    queryKey: queryKeys.trips.detail(id ?? ''),
    queryFn: () => tripsApi.get(id as Id),
    enabled: Boolean(id),
  });
}

export function useUtilization(range: { from: string; to: string }, enabled = true) {
  return useQuery({
    queryKey: queryKeys.trips.utilization(range),
    queryFn: () => tripsApi.utilization(range),
    enabled,
  });
}

/** Raw ping trail — what a trip replay animates along. */
export function useTrail(
  vehicleId: Id | null | undefined,
  range: { from?: string; to?: string; limit?: number },
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.telemetry.trail(vehicleId ?? '', range),
    queryFn: () => telemetryApi.trail(vehicleId as Id, range),
    enabled: Boolean(vehicleId) && enabled,
    staleTime: 60_000,
  });
}

export function useTelemetryStats(
  vehicleId: Id | null | undefined,
  range: { from: string; to: string },
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.telemetry.stats(vehicleId ?? '', range),
    queryFn: () => telemetryApi.stats(vehicleId as Id, range),
    enabled: Boolean(vehicleId) && enabled,
  });
}
